export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0010s_0000_Black-&-White-45.119c6713.png";